import Vue from 'vue';

const success = (context, index, response) => {
  context.messagesLoading = false;
  // noinspection JSAnnotator
  function sortBy(array) {
    let filterA, filterB;
    return  array.sort(function (a, b) {
      filterA = a.created_at;
      filterB = b.created_at;
      return (filterA > filterB) ? 1 : -1;
    })
  }
  let messagesAll = sortBy(response.data.messages);
  context.filteredList[index].messages = messagesAll;
  context.airbnbAccountToken = response.data.token;

  if (response.data.authErrors){
    let authErrors = response.data.authErrors;
    for(let error of authErrors){
      toastr.error(context.$t("account.settings.user_platforms_section.airbnb_auth_error") + " " + error);
    }
  }

};

const failed = (context, response) => {
  context.messagesLoading = false;
  context.showToasterError(response.msg)
};

export default (context, index, id) => {
  return Vue.$http.get('bookings/get-airbnb-messages-specified/'+id)
    .then(response => {
        if(response.status === 200) {
          success(context, index, response);
        }
    }).catch(error => {
      failed(context, response);
  });
}



// WEBPACK FOOTER //
// ./src/app/services/message/getAirbnbMessageForSpecifiedBooking.js